import { createFileRoute } from "@tanstack/react-router";
import { ListingForm } from "@/components/listing-form";
import { JOB_KIND_FIELD, JOB_SEEKER, JOB_VACANCY } from "@/lib/specs";

export const Route = createFileRoute("/_authenticated/yeni-elan")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { tip?: "vakansiya" | "axtaran"; kateqoriya?: string } => ({
    ...(search["tip"] === "vakansiya" || search["tip"] === "axtaran"
      ? { tip: search["tip"] as "vakansiya" | "axtaran" }
      : {}),
    ...(typeof search["kateqoriya"] === "string" && search["kateqoriya"]
      ? { kateqoriya: search["kateqoriya"] }
      : {}),
  }),
  head: () => ({
    meta: [
      { title: "Pulsuz elan yerləşdir — Albazar.az" },
      {
        name: "description",
        content: "15 şəkilə qədər yükləyin, qiymət və şəhər seçin, elanınızı dərhal dərc edin.",
      },
      { property: "og:title", content: "Pulsuz elan yerləşdir — Albazar.az" },
      { property: "og:description", content: "Elanınızı bir neçə dəqiqəyə yerləşdirin." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: NewAd,
});

function NewAd() {
  const { user } = Route.useRouteContext();
  const { tip, kateqoriya } = Route.useSearch();
  const jobKind =
    tip === "vakansiya" ? JOB_VACANCY : tip === "axtaran" ? JOB_SEEKER : undefined;
  const title = jobKind
    ? tip === "axtaran"
      ? "«İş axtarıram» elanı"
      : "İş elanı yerləşdir"
    : kateqoriya === "reklam"
      ? "Reklam yerləşdir"
      : kateqoriya === "masaj"
        ? "Masaj xidməti elanı"
        : kateqoriya === "kosmetoloq"
          ? "Kosmetoloq elanı"
          : "Yeni elan yerləşdir";
  return (
    <div className="container-x max-w-3xl py-10">
      <h1 className="text-3xl font-extrabold tracking-tight">{title}</h1>
      <p className="mt-1 text-sm text-muted-foreground">
        Elanı dərhal dərc edə və ya qaralama kimi saxlaya bilərsiniz.
      </p>
      <ListingForm
        userId={user.id}
        {...(jobKind
          ? { initialCategory: "is-elanlari", initialSpecs: { [JOB_KIND_FIELD]: jobKind } }
          : kateqoriya
            ? { initialCategory: kateqoriya }
            : {})}
      />
    </div>
  );
}